// extracted by mini-css-extract-plugin
export default {"btop":"_0a6e58cf5b _6d3ed1b9be _594ea4909f","icon":"fc0578a0f2 _626076ce8b","btoppink":"_28d4c6d1d2 fb93d7c12f"};